import PageProduct from '@/components/PageProduct';

export default PageProduct;

export async function getStaticProps() {
  return {
    props: {
      path: '/lotto-6aus49',
      theme: 'lotto6aus49',
      description:
        'LOTTO 6aus49 auf einen Blick ✓: Online-Spielschein, aktuelle Gewinnzahlen inkl. Ziehungsvideo und eine kurze Spielanleitung',
      title: 'LOTTO 6aus49 ► Lotterie-Übersicht | LOTTO.de',
      contents: {
        name: 'contents',
        path: '/lotto-6aus49/contents',
        nodes: [
          {
            template: 'lotto:components/pageHeading',
            value: 'LOTTO 6aus49',
          },
          {
            template: 'lotto:components/section',
            link: {
              path: '/lotto-6aus49/lottozahlen',
            },
            title: 'Die aktuellen Gewinnzahlen',
            linkLabel: 'Alle Gewinnzahlen & Quoten',
            contents: {
              name: 'contents',
              nodes: [
                {
                  template: 'lotto:components/winningNumbers',
                  variant: 'lotto6aus49',
                },
                {
                  template: 'lotto:components/drawVideo',
                  variant: 'lotto',
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            title: 'LOTTO 6aus49 auf einen Blick',
            contents: {
              nodes: [
                {
                  template: 'lotto:components/iconList',
                  contents: {
                    name: 'contents',
                    nodes: [
                      {
                        text: '1,20 € je Spielfeld zuzüglich Bearbeitungsgebühren je Spielschein',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-money',
                        title: 'Spieleinsatz',
                      },
                      {
                        text: 'Den Jackpot gewinnen Sie mit einer Chance von 1 zu 139.838.160',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-draw',
                        title: 'Gewinnwahrschein­lichkeit',
                      },
                      {
                        text: 'Jeden Mittwoch um 18:25 Uhr und jeden Samstag um 19:25 Uhr live auf LOTTO.de',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-tv',
                        title: 'Ziehungen',
                      },
                      {
                        text: 'Sie können 1, 2, 3, 4 oder 5 Wochen oder direkt im Dauerspiel mitspielen',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-calendar',
                        title: 'Spielschein-Laufzeit',
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            title: 'So funktioniert LOTTO 6aus49',
            contents: {
              name: 'contents',
              nodes: [
                {
                  template: 'lotto:components/cardSlider',
                  contents: {
                    name: 'contents',
                    path: '/lotto-6aus49/contents/01/contents/0/contents',
                    nodes: [
                      {
                        text: '<p>Auf einem <a href="/lotto-6aus49/spielen">LOTTO-Schein</a> befinden sich - je nach ausgewähltem Bundesland - 12 bis maximal 18 Tippfelder mit jeweils 49 Zahlen. In einem Tippfeld müssen Sie 6 Zahlen ankreuzen. Sie können ein Feld anklicken und die Zahlen selbst ankreuzen oder Sie nutzen bequem unsere Quick-Tipps: damit können Sie ein oder mehrere Tippfelder schnell und bequem per Zufall ausfüllen.</p>',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        title: '1. Lottozahlen tippen',
                        labelPrev: 'Vorheriger Schritt',
                      },
                      {
                        text: '<p>Die Losnummer können Sie einfach per Eingabe von Nummern ändern oder per Zufall eine neue Nummer generieren. Die letzte Ziffer der Losnummer ist Ihre Superzahl für LOTTO 6aus49.</p>\n\n<p>Sie möchten auch an den Zusatzlotterien Spiel 77, SUPER 6 oder GlücksSpirale teilnehmen? Mit der Losnummer definieren Sie auch die Nummern für die Zusatzlotterien.</p>',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        title: '2. Losnummer und Zusatzlotterien wählen',
                        labelPrev: 'Vorheriger Schritt',
                      },
                      {
                        text: '<p>Wählen Sie die Ziehung am Mittwoch, am Samstag oder an beiden kommenden Ziehungstagen von LOTTO 6aus49 aus.</p>\n\n<p>Als Laufzeit für Ihren Lottoschein können Sie zwischen einer und fünf Wochen wählen. Mit einem Dauerspiel wird Ihr Spielschein bei Ihrer Landeslotteriegesellschaft automatisch verlängert.</p>\n',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        labelPrev: 'Vorheriger Schritt',
                        title: '3. Ziehungen und Anzahl der Wochen wählen',
                      },
                      {
                        text: '<p>Ihren Spieltipp für die Abgabe bei Ihrer Landeslotteriegesellschaft fassen wir noch einmal in einer Übersicht mit allen relevanten Angaben zusammen.</p>',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        labelPrev: 'Vorheriger Schritt',
                        title: '4. Übersicht Ihres Spieltipps',
                      },
                      {
                        text: '<p>Ihren LOTTO 6aus49-Spielschein können Sie bei der Landeslotteriegesellschaft Ihres Bundeslandes abgeben. Falls Sie dort bereits registrierter Nutzer sind, können Sie sich einfach anmelden und den Spielschein abgeben. Falls Sie noch kein Kunde einer Landeslotteriegesellschaft sind, müssen Sie erst den Registrierungsprozess in Ihrem Bundesland abschließen.</p>',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        title: '5. Anmelden oder registrieren',
                        labelPrev: 'Vorheriger Schritt',
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            title: 'Neuigkeiten von LOTTO 6aus49',
            contents: {
              name: 'contents',
              nodes: [
                {
                  category: 'lotto6aus49',
                  template: 'lotto:components/newsTeaser',
                  amount: 2,
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            title: 'Zusatzchancen mit Spiel 77 & SUPER 6',
            contents: {
              name: 'contents',
              nodes: [
                {
                  template: 'lotto:components/tilesGameTeaser',
                  contents: {
                    name: 'contents',
                    nodes: [
                      {
                        text: 'Auf LOTTO.de können Sie bei LOTTO 6aus49 oder auf einem GlücksSpirale-Los die Zusatzlotterie Spiel 77 für zusätzliche Gewinnchancen ankreuzen.',
                        game: '7',
                        template: 'lotto:components/tilesGameTeaserItem',
                        link: {
                          path: '/lotto-6aus49/spiel77-super6/spielregeln',
                        },
                        title: 'Zusatzlotterie Spiel 77',
                      },
                      {
                        text: 'SUPER 6 ist eine Zusatzlotterie mit festen Gewinnquoten, die Sie auf LOTTO.de in Verbindung mit LOTTO 6aus49 und der GlücksSpirale spielen können. ',
                        game: '6',
                        template: 'lotto:components/tilesGameTeaserItem',
                        link: {
                          path: '/lotto-6aus49/spiel77-super6/spielregeln',
                        },
                        title: 'Zusatzlotterie SUPER 6',
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            title: 'Sicherheit bei LOTTO.de',
            hideLine: true,
            contents: {
              name: 'contents',
              nodes: [
                {
                  template: 'lotto:components/iconList',
                  contents: {
                    name: 'contents',
                    nodes: [
                      {
                        text: 'Wir leiten Ihren Spielschein-Tipp mit einer sicheren Verbindung an die Landes­lotterie­gesellschaft Ihres Bundeslandes weiter - dort können Sie online spielen.',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-shield',
                        title: 'Sicher & legal',
                      },
                      {
                        text: 'Rechtliche Grundlage für erlaubtes Glücksspiel in Deutschland sind der Glücksspielstaatsvertrag und die Glücksspiel­gesetze der Länder. ',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-court',
                        title: 'Staatlich erlaubt',
                      },
                      {
                        text: 'Im Gewinnfall haben Sie bei staatlich erlaubten Lotterien einen Rechtsanspruch auf eine garantierte Auszahlung durch die Landes­lotterie­gesellschaften. ',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-payoff',
                        title: 'Garantierte Auszahlung',
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            hideLine: true,
            contents: {
              name: 'contents',
              nodes: [
                {
                  game: '4',
                  template: 'lotto:components/linkGame',
                },
              ],
            },
          },
        ],
      },
    },
  };
}
